/*
  Aurev collection page — filter drawer, live result count, grid column toggle,
  infinite scroll and colour swatches for sections/aurev-collection-main.liquid.
*/
(function () {
  if (window.AurevCollection) return;

  var desktop = window.matchMedia('(min-width: 990px)');

  function read(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function write(key, value) { try { window.localStorage.setItem(key, value); } catch (e) { /* ignore */ } }
  function withSection(url, sectionId) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId; }

  function initSection(root) {
    if (root.dataset.acgReady) return;
    root.dataset.acgReady = '1';
    root.classList.add('is-js');

    var sectionId = root.dataset.sectionId;
    var form = root.querySelector('[data-acg-form]');
    var grid = root.querySelector('[data-acg-grid]');
    if (!form || !grid) return;

    /* ---------- Grid columns (remembered) ---------- */
    // Card photos are told how wide they display, so the browser picks a sharp
    // enough file for one column without downloading oversized ones for four.
    function applySizes() {
      var sizes = desktop.matches ? (grid.dataset.colsD === '3' ? '33vw' : '25vw') : (grid.dataset.colsM === '1' ? '100vw' : '50vw');
      grid.querySelectorAll('img.acg-card__img--main[srcset]').forEach(function (img) {
        if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
      });
    }
    function applyCols() {
      var m = read('aurev-cols-m') || root.dataset.colsMobile || '2';
      var d = read('aurev-cols-d') || root.dataset.colsDesktop || '4';
      grid.dataset.colsM = m;
      grid.dataset.colsD = d;
      root.querySelectorAll('[data-acg-cols]').forEach(function (btn) {
        var want = btn.dataset.acgBp === 'mobile' ? m : d;
        var on = btn.dataset.acgCols === want;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applySizes();
    }
    root.querySelectorAll('[data-acg-cols]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        write(btn.dataset.acgBp === 'mobile' ? 'aurev-cols-m' : 'aurev-cols-d', btn.dataset.acgCols);
        applyCols();
      });
    });
    applyCols();
    if (desktop.addEventListener) desktop.addEventListener('change', applySizes);
    else if (desktop.addListener) desktop.addListener(applySizes);

    /* ---------- Drawer (mobile) ---------- */
    var openBtn = root.querySelector('[data-acg-open]');
    function setOpen(open) {
      root.classList.toggle('is-filter-open', open);
      document.body.classList.toggle('acg-lock', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    root.querySelectorAll('[data-acg-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    /* ---------- Filter groups: expanded in the drawer, dropdowns on desktop ---------- */
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-acg-group]'));
    function syncGroups() { groups.forEach(function (g) { g.open = !desktop.matches; }); }
    function closeDropdowns(except) {
      if (!desktop.matches) return;
      groups.forEach(function (g) { if (g !== except) g.open = false; });
    }
    syncGroups();
    if (desktop.addEventListener) desktop.addEventListener('change', syncGroups);
    else if (desktop.addListener) desktop.addListener(syncGroups);
    groups.forEach(function (g) {
      g.addEventListener('toggle', function () { if (g.open) closeDropdowns(g); });
    });
    document.addEventListener('click', function (e) {
      if (desktop.matches && !e.target.closest('[data-acg-group]')) closeDropdowns();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setOpen(false); closeDropdowns(); }
    });
    root.querySelectorAll('[data-acg-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = btn.previousElementSibling;
        if (list) list.classList.add('is-expanded');
        btn.remove();
      });
    });

    /* ---------- Filtering ---------- */
    function buildUrl() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      var query = params.toString();
      return form.getAttribute('action') + (query ? '?' + query : '');
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      window.location.href = buildUrl();
    });

    var see = root.querySelector('[data-acg-see]');
    var countTimer, countRequest = 0;
    function updateCount() {
      if (!see) return;
      var requestId = ++countRequest;
      fetch(withSection(buildUrl(), sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (requestId !== countRequest) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var count = doc.querySelector('[data-acg-count]');
          if (count) see.textContent = count.getAttribute('data-acg-count');
        })
        .catch(function () { /* keep the old number */ });
    }
    form.addEventListener('change', function () {
      if (desktop.matches) {
        window.location.href = buildUrl();
        return;
      }
      clearTimeout(countTimer);
      countTimer = setTimeout(updateCount, 250);
    });

    /* ---------- Load more / infinite scroll ---------- */
    var loadBtn = root.querySelector('[data-acg-load]');
    var loading = false;
    var observer = null;

    function nearViewport(el) {
      return el.getBoundingClientRect().top < window.innerHeight + 800;
    }
    function loadMore() {
      if (!loadBtn || loading) return;
      loading = true;
      loadBtn.classList.add('is-loading');
      loadBtn.textContent = 'Loading…';
      fetch(withSection(loadBtn.dataset.next, sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-acg-grid] > [data-acg-card]').forEach(function (card) {
            grid.appendChild(card);
          });
          applySizes();
          var next = doc.querySelector('[data-acg-load]');
          loading = false;
          if (next) {
            loadBtn.dataset.next = next.dataset.next;
            loadBtn.classList.remove('is-loading');
            loadBtn.textContent = loadBtn.dataset.label || 'Load more';
            if (observer && nearViewport(loadBtn)) loadMore();
          } else {
            var wrap = root.querySelector('[data-acg-more-wrap]');
            if (wrap) wrap.remove();
            if (observer) observer.disconnect();
            loadBtn = null;
          }
        })
        .catch(function () {
          loading = false;
          if (loadBtn) {
            loadBtn.classList.remove('is-loading');
            loadBtn.textContent = loadBtn.dataset.label || 'Load more';
          }
        });
    }
    if (loadBtn) {
      loadBtn.addEventListener('click', loadMore);
      if (root.dataset.infinite === 'true' && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) loadMore(); });
        }, { rootMargin: '0px 0px 800px 0px' });
        observer.observe(loadBtn);
      }
    }

    /* ---------- Colour swatches ---------- */
    grid.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-acg-swatch]');
      if (!swatch) return;
      var card = swatch.closest('[data-acg-card]');
      var img = card.querySelector('.acg-card__img--main');
      if (img && swatch.dataset.src) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = swatch.dataset.src;
      }
      card.classList.add('has-swatch');
      card.querySelectorAll('[data-acg-link]').forEach(function (a) { a.href = swatch.dataset.url; });
      card.querySelectorAll('[data-acg-swatch]').forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-acg]').forEach(initSection);
  }

  window.AurevCollection = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
